import type { FaireProductEntity } from "../../entity_types/product";

export const p_tcavw9bfb4: FaireProductEntity = {
  token: "p_tcavw9bfb4",
  type: "product",
  name: "RESURFACE | Gel Mask | Glycolic Acid Chemical Peel",
  brandToken: "b_6r1eum8lfs",
  brandName: "Wonderfully Made .love",
  imageUrl:
    "https://cdn.faire.com/fastly/2534bbac8e52bf043ba8ac23de488e4654015955ca91107c5c7bd2eccc62a836.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a74d7e90e63608ade6ff9bc1f288dde4ebe48d0ad9a4414f5718266f3573e289.png",
    "https://cdn.faire.com/fastly/bc9dca827ce31bf541c7b061bb57238f3409f699e66b269ed788e8b00678cdba.jpeg",
  ],
  priceDollars: 14.11,
  description:
    "✷ OVERVIEW ✷\n\n\n\n✷ DETAILS ✷\n\nKey ingredients: Glycolic Acid, Rose, Konjac. \n\nDirections: Apply a thin layer onto face. Rinse off after 5-20 minutes. \n\nSize: 15 ml glass bottle with pump.\n\n\n\n✷ SHIPPING + DELIVERY ✷\n\nAll orders over $35 ship for FREE!\n\nI strive to ship items in 1-5 days, however, some items may take up to 7 days. I ship USPS first class with tracking. You can also upgrade the shipping to USPS priority for faster shipping speeds! If you have a deadline that you need your item, just message me, and we will make sure it arrives on time!\n\n\n\n ✷ THANKFUL ✷\n\nAs always, thank you for supporting a mother in Tennessee. ❤ \n\nAll items are handmade with the finest ingredients possible, all organic, wild-harvested, and local when possible, including several that are grown right here on our sustainable farm in Tennessee! 💚\n\nAll self-care apothecary items are handmade in small batches with LOVE! \n",
  tags: [],
  msrpDollars: 23.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:10.723Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
